import React from 'react';

const content = {
	'User Activites': [
		{ title: 'Community Feed', starter: true, pro: true, premium: true },
		{ title: 'Friends Invitation', starter: true, pro: true, premium: true },
		{ title: 'Customization (color, name...)', starter: true, pro: true, premium: true },
		{ title: 'Create all type of posts', starter: true, pro: true, premium: true },
		{ title: 'User notification on answers', starter: true, pro: true, premium: true },
	],
	'Brand Imprint': [
		{ title: 'Challenge', starter: false, pro: true, premium: true },
		{ title: 'Schedule Posts', starter: false, pro: true, premium: true },
		{ title: 'Dashboard', starter: false, pro: true, premium: true },
		{ title: 'Collect Video Review', starter: false, pro: true, premium: true },
		{ title: 'Influencer Page', starter: false, pro: true, premium: true },
		{ title: 'Moderation in Dashboard', starter: false, pro: true, premium: true },
		{ title: 'Feed in Dashboard', starter: false, pro: true, premium: true },
	],
};
const PlansComparison = props => {
	const { selected } = props;
	return (
		<>
			<div className='title'>
				<p>Our Plans Comparison</p>
			</div>
			<div>
				<div className='features-table'>
					<div className='table-headers'>
						<div
							className={`header-col ${selected === 'starter' ? 'active' : ''}`}
							ng-reflect-klass='header-col'
						>
							Starter
						</div>
						<div
							className={`header-col ${selected === 'pro' ? 'active' : ''}`}
							ng-reflect-klass='header-col'
						>
							Pro
						</div>
					</div>
					<div className='shadows'></div>
					<div className='cover'></div>
					{Object.keys(content).map(item => (
						<div className='features-content' key={item}>
							<div className='features-category-header'>
								<p>{item}</p>
								<div className={`fill-3' ${selected === 'starter' ? 'active' : ''}`}></div>
								<div className={`fill-3' ${selected === 'pro' ? 'active' : ''}`}></div>
							</div>
							{content[item].map(e => (
								<div
									className='feature-row'
									hide-delay='0'
									placement='left'
									show-delay='1000'
									key={e.title}
								>
									<div className='feature-col'>
										<span className='feature-name'>{e.title}</span>
									</div>
									<div className={`plan-has-feature ${selected === 'starter' ? 'active' : ''}`}>
										{e.starter && <div className='check'></div>}
									</div>
									<div className={`plan-has-feature ${selected === 'pro' ? 'active' : ''}`}>
										{e.pro && <div className='check'></div>}
									</div>
								</div>
							))}
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default PlansComparison;
